import { RestoreResponseDTO } from 'business/models/Models';
import React from 'react';

type Props = {
  response: RestoreResponseDTO;
};
export const RestoreResponseModalBody = (props: Props) => {
  const { response } = props;
  const { errors, warnings } = response;
  return (
    <div id='explorer-restoreresponsemodalbody-wrapper'>
      {warnings.length > 0 && (
        <div id="explorer-restoreresponsemodalbody-warnings">
          Following files have been restored with some changes.
          <br />
          {warnings.map((warning, index) => (
            <div id={`explorer-restoreresponsemodalbody-warning-${index}`}
              key={`restore-warning-${index}`} className="ml-4">
              {index + 1}- {warning}
            </div>
          ))}
        </div>
      )}
      {errors.length > 0 && (
        <div id="explorer-restoreresponsemodalbody-errors">
          The following item(s) can&apos;t be restored as the destination folder may have
          been permanently deleted:
          <br />
          {errors.map((error, index) => (
            <div id={`explorer-restoreresponsemodalbody-error-${index}`}
              key={`restore-error-${index}`} className="text-red-800 ml-4">
              - {error}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
